import { type JssStyle } from 'jss';

// Re-exported so every existing `import { hashCode } from '@common/helpers/formatter'` keeps
// working; it lives in its own import-free file now so a node service can reach it without JSS.
export { hashCode } from './hash';

export function formatStylesToPx(data: JssStyle): JssStyle {
    // TODO: REMOVE THIS METHOD
    const formattedData = { ...data };

    Object.keys(formattedData).forEach((item) => {
        if (typeof formattedData[item] === 'number') {
            // TODO: implement rules and logic to change and control css units;
            if (item === 'lineHeight') {
                return (formattedData[item] = `${formattedData[item]}%`);
            }

            return (formattedData[item] = `${formattedData[item]}px`);
        }
    });

    return formattedData;
}

export function getValuesAsString(values: Record<string, string>): string {
    return Object.entries(values).reduce((str: string, [key, value]) => `${str}${key}: ${value};\n`, '');
}

export function formattedDateTimeNow(): string {
    const d = new Date();

    return `${[d.getMonth() + 1, d.getDate(), d.getFullYear()].join('/')}_${[
        d.getHours(),
        d.getMinutes(),
        d.getSeconds(),
    ].join('-')}`;
}
